/**
 * <xo-footer-accordion>
 * Collapsible footer nav columns on mobile (< 768px); always expanded on desktop.
 * Uses event delegation on the title buttons and a shared matchMedia listener.
 */
if (!customElements.get('xo-footer-accordion')) {
  customElements.define(
    'xo-footer-accordion',
    class XoFooterAccordion extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(max-width: 767px)');
        this.onClick = this.onClick.bind(this);
        this.onChange = this.onChange.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
        this.mql.addEventListener('change', this.onChange);
        this.syncMode();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.mql.removeEventListener('change', this.onChange);
      }

      get navs() {
        return Array.from(this.querySelectorAll('.xo-footer-nav'));
      }

      onChange() {
        this.syncMode();
      }

      /* On desktop force every panel open; on mobile collapse all by default. */
      syncMode() {
        const collapsible = this.mql.matches;
        this.navs.forEach((nav) => {
          const title = nav.querySelector('.xo-footer-nav__title');
          if (!title) return;
          if (collapsible) {
            this.setOpen(nav, title, nav.classList.contains('is-open'));
          } else {
            this.setOpen(nav, title, true);
          }
        });
      }

      onClick(event) {
        if (!this.mql.matches) return;
        const title = event.target.closest('.xo-footer-nav__title');
        if (!title || !this.contains(title)) return;
        const nav = title.closest('.xo-footer-nav');
        if (!nav) return;
        this.setOpen(nav, title, !nav.classList.contains('is-open'));
      }

      setOpen(nav, title, open) {
        nav.classList.toggle('is-open', open);
        title.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }
  );
}
